/**
 * Lệnh Bot — Cấu hình Create Catalogue (/createcatalogue).
 *
 * Route: `/admin/lenh-bot/create-catalogue`
 */

export const CREATE_CATALOGUE_ROUTE_NAME = 'LenhBotCreateCatalogue'
export const CREATE_CATALOGUE_ITEM_ID = 'lenh-bot-create-catalogue'
export const CREATE_CATALOGUE_LABEL = 'Cấu hình Create Catalogue'
export const CREATE_CATALOGUE_TITLE = 'Lệnh Bot · Cấu hình Create Catalogue'
